import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';
const EmployeeList = Loadable(lazy(() => import('./EmployeeList')));
const AddEmployee = Loadable(lazy(() => import('./AddEmployee')));


const EmpRoutes = [	
	{
		path: '/employee/list',
		element: <EmployeeList />,
		auth: authRoles.admin,
	},
	{
		path: '/employee/manage',
		element: <AddEmployee />,
		auth: authRoles.admin,
	},
	
];

export default EmpRoutes;
